module.exports = __webpack_public_path__ + "img/lottery-2.ccb50e6d.svg";